import React from "react";
import {Col, Container, Row} from "react-bootstrap";
import SalesChart from "./SalesChart";
import {withRouter} from "react-router-dom";
import HelperGeneral from "../../helpers/HelperGeneral";
import Api from "../../services/Api";
import {Spin} from "antd";
import moment from "moment";

class ReportDashboard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            info: {},
            salesLoading: false,
            salesDateBetween: '1-year',
            salesInfo: [],
            scoreLoading: false,
            scoreDateBetween: '1-year',
            scoreInfo: {}
        }
    }

    componentDidMount() {
        // this.salesDateBetween('1-year');
        // this.scoreDateBetween('1-year');
    }

    dateBetween(v) {
        const a = v.split('-');
        let start = moment().subtract(a[0], a[1]);
        if (v === '3-month') {
            start = start.endOf('month').add(1, 'day');
        } else if (v === '1-month') {
            start = moment().startOf('month');
        } else if (v === '1-year') {
            start = moment(moment().format('YYYY') + '-01-01');
        }
        const startDate = start.format('YYYY-MM-DD');
        const endDate = moment().format('YYYY-MM-DD');
        return {startDate, endDate};
    }

    getSalesChart(startDate, endDate) {
        this.setState({salesLoading: true, salesInfo: []}, () => {
            Api.getSalesChart(startDate, endDate).then((e) => {
                this.setState({
                    salesLoading: false,
                    salesInfo: e?.data?.result
                });
            }).catch((e) => this.setState({salesLoading: false}, () => HelperGeneral.alert(e)));
        });
    }

    getScoreSummary(startDate, endDate) {
        this.setState({scoreLoading: true}, () => {
            Api.getScoreSummary(startDate, endDate).then((e) => {
                this.setState({
                    scoreLoading: false,
                    scoreInfo: e?.data?.result
                });
            }).catch((e) => this.setState({scoreLoading: false}, () => HelperGeneral.alert(e)));
        });
    }

    salesDateBetween(v) {
        const {startDate, endDate} = this.dateBetween(v);
        this.setState({salesDateBetween: v}, () => this.getSalesChart(startDate, endDate));
    }

    scoreDateBetween(v) {
        const {startDate, endDate} = this.dateBetween(v);
        this.setState({scoreDateBetween: v}, () => this.getScoreSummary(startDate, endDate));
    }

    render() {
        const {salesLoading, salesDateBetween, salesInfo, scoreDateBetween, scoreLoading, scoreInfo} = this.state;

        return (
            <Row>
                <Col xs={12} xl={6} className={"d-flex h-100 justify-content-center"}>
                    <Spin spinning={scoreLoading}>
                        <div className={'box report report-1'}>
                            <div className={'header'}>
                                <Row>
                                    <Col xs={12} sm={'auto'}>
                                        <div className={'title mb-3 mb-sm-0'}>Puan Özetiniz</div>
                                    </Col>
                                    <Col>
                                        <div className={'filter-area'}>
                                            <div
                                                className={scoreDateBetween === '1-week' ? 'active' : ''}
                                                // onClick={() => this.scoreDateBetween('1-week')}
                                            >
                                                7 GÜN
                                            </div>
                                            <div
                                                className={scoreDateBetween === '1-month' ? 'active' : ''}
                                                // onClick={() => this.scoreDateBetween('1-month')}
                                            >
                                                1 AY
                                            </div>
                                            <div
                                                className={scoreDateBetween === '3-month' ? 'active' : ''}
                                                // onClick={() => this.scoreDateBetween('3-month')}
                                            >
                                                3 AY
                                            </div>
                                            <div
                                                className={scoreDateBetween === '1-year' ? 'active' : ''}
                                                // onClick={() => this.scoreDateBetween('1-year')}
                                            >
                                                1 YIL
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <div className={'main'}>
                                <div className={'top'}>
                                    <div>MEVCUT PUANINIZ</div>
                                    <div>{HelperGeneral.formatNumber(scoreInfo?.currentScore) ?? 0}</div>
                                </div>
                                <div className={'info'}>
                                    <Container>
                                        <Row>
                                            <Col xs={12} md={true} className={'pe-0 ps-0'}>
                                                <div className={'area'}>
                                                    <div>DÖNEM ÖZETİ</div>
                                                    <div>
                                                        <span className={'b'}>{scoreInfo?.periodSummary?.dateRange ?? '-'}</span>
                                                    </div>
                                                    <Row>
                                                        <Col xs={12} md={4}>Kazandığınız puan</Col>
                                                        <Col xs={12} md={8}>
                                                            <span className={'b'}>{scoreInfo?.periodSummary?.PointsYouEarn ?? '-'}</span>
                                                        </Col>
                                                        {/*<Col xs={12} md={4}>Toplam satış tutarı</Col>*/}
                                                        {/*<Col xs={12} md={8} className={'pe-0'}>*/}
                                                        {/*    <span className={'b'}>*/}
                                                        {/*        {*/}
                                                        {/*            scoreInfo?.periodSummary?.totalSalesAmount !== undefined ? (*/}
                                                        {/*                HelperGeneral.formatMoneyTL(scoreInfo?.periodSummary?.totalSalesAmount)*/}
                                                        {/*            ) : (*/}
                                                        {/*                '-'*/}
                                                        {/*            )*/}
                                                        {/*        }*/}
                                                        {/*    </span>*/}
                                                        {/*</Col>*/}
                                                        <Col xs={12} md={4}>Sattığınız ürün sayısı</Col>
                                                        <Col xs={12} md={8}>
                                                            <span className={'b'}>{scoreInfo?.periodSummary?.sellProductCount ?? '-'}</span>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                            {/*<Col xs={12} md={true} className={'total-gain-col'}>*/}
                                            {/*    <div className={'area'}>*/}
                                            {/*        <div>TOPLAM KAZANCINIZ</div>*/}
                                            {/*        <div>*/}
                                            {/*            <span className={'b'}>{scoreInfo?.totalGains?.dateRange ?? '-'}</span>*/}
                                            {/*        </div>*/}
                                            {/*        <Row>*/}
                                            {/*            <Col xs={12} md={9}>Kazandığınız toplam puan</Col>*/}
                                            {/*            <Col xs={12} md={3}>*/}
                                            {/*                <span className={'b'}>{scoreInfo?.totalGains?.totalPointsEarned ?? '-'}</span>*/}
                                            {/*            </Col>*/}
                                            {/*            <Col xs={12} md={9}>Kazancınız (TL karşılığı)</Col>*/}
                                            {/*            <Col xs={12} md={3}>*/}
                                            {/*                <span className={'b'}>*/}
                                            {/*                    {*/}
                                            {/*                        scoreInfo?.totalGains?.yourEarnings !== undefined ? (*/}
                                            {/*                            HelperGeneral.formatMoneyTL(scoreInfo?.totalGains?.yourEarnings)*/}
                                            {/*                        ) : (*/}
                                            {/*                            '-'*/}
                                            {/*                        )*/}
                                            {/*                    }*/}
                                            {/*                </span>*/}
                                            {/*            </Col>*/}
                                            {/*        </Row>*/}
                                            {/*    </div>*/}
                                            {/*</Col>*/}
                                        </Row>
                                    </Container>
                                </div>
                            </div>
                        </div>
                    </Spin>
                </Col>
                <Col xs={12} xl={6} className={"d-flex h-100 justify-content-center graph-col"}>
                    <Spin spinning={salesLoading}>
                        <div className={'box report w-100 report-2'}>
                            <div className={'header w-100'}>
                                <Row>
                                    <Col className={''}>
                                        <div className={'title mb-3 mb-sm-0'}>Satış Grafiğiniz</div>
                                    </Col>
                                    <Col>
                                        <div className={'filter-area'}>
                                            <div
                                                className={salesDateBetween === '1-week' ? 'active' : ''}
                                                // onClick={() => this.salesDateBetween('1-week')}
                                            >
                                                7 GÜN
                                            </div>
                                            <div
                                                className={salesDateBetween === '1-month' ? 'active' : ''}
                                                // onClick={() => this.salesDateBetween('1-month')}
                                            >
                                                1 AY
                                            </div>
                                            <div
                                                className={salesDateBetween === '3-month' ? 'active' : ''}
                                                // onClick={() => this.salesDateBetween('3-month')}
                                            >
                                                3 AY
                                            </div>
                                            <div
                                                className={salesDateBetween === '1-year' ? 'active' : ''}
                                                // onClick={() => this.salesDateBetween('1-year')}
                                            >
                                                1 YIL
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <div className={'main'}>
                                <SalesChart data={salesInfo} salesDateBetween={salesDateBetween}/>
                            </div>
                        </div>
                    </Spin>
                </Col>
            </Row>
        );
    }
}

export default withRouter(ReportDashboard);
